import chicken from '../../../assets/src/images/shuffler/chicken.png';
import giraffe from '../../../assets/src/images/shuffler/giraffe.png';
import horse from '../../../assets/src/images/shuffler/horse.png';
import koala from '../../../assets/src/images/shuffler/koala.png';
import pig from '../../../assets/src/images/shuffler/pig.png';

export type Shuffler = {
  object: ShuffleObject;
  color: string;
  adjective: string;
};

type ShuffleObject = {
  avatar: any;
  noun: string;
};

const emojiArray = [
  '✌',
  '😂',
  '😝',
  '😁',
  '😱',
  '👉',
  '🙌',
  '🍻',
  '🔥',
  '🌈',
  '☀',
  '🎈',
  '🌹',
  '💄',
  '🎀',
  '⚽',
  '🎾',
  '🏁',
  '😡',
  '👿',
  '🐻',
  '🐶',
  '🐬',
  '🐟',
  '🍀',
  '👀',
  '🚗',
  '🍎',
  '💝',
  '💙',
  '👌',
  '❤',
  '😍',
  '😉',
  '😓',
  '😳',
  '💪',
  '💩',
  '🍸',
  '🔑',
  '💖',
  '🌟',
  '🎉',
  '🌺',
  '🎶',
  '👠',
  '🏈',
  '⚾',
  '🏆',
  '👽',
  '💀',
  '🐵',
  '🐮',
  '🐩',
  '🐎',
  '💣',
  '👃',
  '👂',
  '🍓',
  '💘',
  '💜',
  '👊',
  '💋',
  '😘',
  '😜',
  '😵',
  '🙏',
  '👋',
  '🚽',
  '💃',
  '💎',
  '🚀',
  '🌙',
  '🎁',
  '⛄',
  '🌊',
  '⛵',
  '🏀',
  '🎱',
  '💰',
  '👶',
  '👸',
  '🐰',
  '🐷',
  '🐍',
  '🐫',
  '🔫',
  '👄',
  '🚲',
  '🍉',
  '💛',
  '💚',
];

export const adjectives: string[] = [
  'abandoned',
  'absolute',
  'adorable',
  'adventurous',
  'academic',
  'acceptable',
  'acclaimed',
  'accomplished',
  'accurate',
  'acidic',
  'acrobatic',
  'adept',
  'admirable',
  'adorable',
  'advanced',
  'afraid',
  'affectionate',
  'aggressive',
  'agile',
  'agitated',
  'agonizing',
  'agreeable',
  'alarmed',
  'alienated',
  'altruistic',
  'amazing',
  'ambitious',
  'ample',
  'amused',
  'amusing',
  'anchored',
  'ancient',
  'angelic',
  'angry',
  'another',
  'antique',
  'anxious',
  'arctic',
  'aromatic',
  'artistic',
  'ashamed',
  'astonishing',
  'athletic',
  'attached',
  'attentive',
  'attractive',
  'authentic',
  'average',
  'aware',
  'awesome',
  'awful',
  'awkward',
  'baby',
  'bad',
  'baggy',
  'bare',
  'barren',
  'basic',
  'beautiful',
  'belated',
  'beloved',
  'better',
  'bewitched',
  'big',
  'biodegradable',
  'bitter',
  'bland',
  'blaring',
  'bleak',
  'blind',
  'blissful',
  'blond',
  'blushing',
  'bogus',
  'boiling',
  'bony',
  'boring',
  'bossy',
  'bouncy',
  'bountiful',
  'brave',
  'breakable',
  'brief',
  'bright',
  'brilliant',
  'brisk',
  'broken',
  'bronze',
  'bruised',
  'bubbly',
  'bulky',
  'bumpy',
  'buoyant',
  'burdensome',
  'burly',
  'bustling',
  'buttery',
  'buzzing',
  'calculating',
  'calm',
  'candid',
  'carefree',
  'careful',
  'careless',
  'caring',
  'cavernous',
  'celebrated',
  'charming',
  'cheerful',
  'cheery',
  'chief',
  'chilly',
  'chubby',
  'classic',
  'clean',
  'clear',
  'clever',
  'close',
  'closed',
  'cloudy',
  'clueless',
  'clumsy',
  'cluttered',
  'coarse',
  'cold',
  'colorful',
  'colorless',
  'colossal',
  'common',
  'competent',
  'complex',
  'composed',
  'concerned',
  'concrete',
  'confused',
  'conscious',
  'constant',
  'content',
  'cooked',
  'cool',
  'corny',
  'corrupt',
  'costly',
  'courageous',
  'courteous',
  'crafty',
  'crazy',
  'creamy',
  'creative',
  'creepy',
  'criminal',
  'crisp',
  'critical',
  'crooked',
  'crowded',
  'cruel',
  'crushing',
  'cuddly',
  'cultivated',
  'cultured',
  'cumbersome',
  'curly',
  'curvy',
  'cute',
  'damaged',
  'dangerous',
  'dapper',
  'daring',
  'darling',
  'dark',
  'dazzling',
  'dead',
  'deadly',
  'dear',
  'dearest',
  'decent',
  'decimal',
  'decisive',
  'deep',
  'defiant',
  'deficient',
  'delayed',
  'delectable',
  'delicious',
  'delightful',
  'delirious',
  'demanding',
  'dense',
  'dental',
  'deserted',
  'detailed',
  'determined',
  'devoted',
  'different',
  'difficult',
  'digital',
  'diligent',
  'dimpled',
  'disastrous',
  'disfigured',
  'disgusting',
  'disloyal',
  'distant',
  'dirty',
  'disguised',
  'dishonest',
  'distant',
  'distinct',
  'distorted',
  'dizzy',
  'dopey',
  'doting',
  'double',
  'downright',
  'drab',
  'drafty',
  'dramatic',
  'dreary',
  'droopy',
  'dry',
  'dual',
  'dull',
  'dutiful',
  'each',
  'eager',
  'earnest',
  'early',
  'easy',
  'ecstatic',
  'edible',
  'educated',
  'elaborate',
  'elastic',
  'elated',
  'elderly',
  'electric',
  'elegant',
  'elementary',
  'eminent',
  'emotional',
  'empty',
  'enchanted',
  'enchanting',
  'energetic',
  'enlightened',
  'enormous',
  'enraged',
  'entire',
  'envious',
  'equal',
  'equatorial',
  'essential',
  'esteemed',
  'ethical',
  'euphoric',
  'even',
  'evergreen',
  'everlasting',
  'every',
  'evil',
  'exalted',
  'excellent',
  'exemplary',
  'exhausted',
  'excitable',
  'excited',
  'exciting',
  'exotic',
  'expensive',
  'experienced',
  'expert',
  'extraneous',
  'extroverted',
  'fabulous',
  'failing',
  'faint',
  'fair',
  'faithful',
  'fake',
  'false',
  'familiar',
  'famous',
  'fancy',
  'fantastic',
  'far',
  'faraway',
  'fast',
  'fat',
  'fatal',
  'fatherly',
  'favorable',
  'favorite',
  'fearful',
  'fearless',
  'feisty',
  'feline',
  'female',
  'feminine',
  'few',
  'fickle',
  'filthy',
  'fine',
  'finished',
  'firm',
  'first',
  'firsthand',
  'fitting',
  'fixed',
  'flaky',
  'flamboyant',
  'flashy',
  'flat',
  'flawed',
  'flawless',
  'flickering',
  'flimsy',
  'flippant',
  'flowery',
  'fluffy',
  'fluid',
  'flustered',
  'focused',
  'fond',
  'foolhardy',
  'foolish',
  'forceful',
  'forked',
  'formal',
  'forsaken',
  'forthright',
  'fortunate',
  'fragrant',
  'frail',
  'frank',
  'frayed',
  'free',
  'French',
  'fresh',
  'frequent',
  'friendly',
  'frightened',
  'frightening',
  'frigid',
  'frilly',
  'frizzy',
  'frivolous',
  'front',
  'frosty',
  'frozen',
  'frugal',
  'fruitful',
  'full',
  'fumbling',
  'functional',
  'funny',
  'fussy',
  'fuzzy',
  'gargantuan',
  'gaseous',
  'general',
  'generous',
  'gentle',
  'genuine',
  'giant',
  'giddy',
  'gigantic',
  'gifted',
  'giving',
  'glamorous',
  'glaring',
  'glass',
  'gleaming',
  'gleeful',
  'glistening',
  'glittering',
  'gloomy',
  'glorious',
  'glossy',
  'glum',
  'golden',
  'good',
  'gorgeous',
  'graceful',
  'gracious',
  'grand',
  'grandiose',
  'granular',
  'grateful',
  'grave',
  'great',
  'greedy',
  'gregarious',
  'grim',
  'grimy',
  'gripping',
  'grizzled',
  'gross',
  'grotesque',
  'grouchy',
  'grounded',
  'growing',
  'growling',
  'grown',
  'grubby',
  'gruesome',
  'grumpy',
  'guilty',
  'gullible',
  'gummy',
  'hairy',
  'half',
  'handmade',
  'handsome',
  'handy',
  'happy',
  'hard',
  'harmful',
  'harmless',
  'harmonious',
  'harsh',
  'hasty',
  'hateful',
  'haunting',
  'healthy',
  'heartfelt',
  'hearty',
  'heavenly',
  'heavy',
  'hefty',
  'helpful',
  'helpless',
  'hidden',
  'hideous',
  'high',
  'hilarious',
  'hoarse',
  'hollow',
  'homely',
  'honest',
  'honorable',
  'honored',
  'hopeful',
  'horrible',
  'hospitable',
  'hot',
  'huge',
  'humble',
  'humiliating',
  'humming',
  'humongous',
  'hungry',
  'hurtful',
  'husky',
  'icky',
  'icy',
  'ideal',
  'idealistic',
  'identical',
  'idle',
  'idiotic',
  'idolized',
  'ignorant',
  'ill',
  'illegal',
  'illiterate',
  'imaginary',
  'imaginative',
  'immaculate',
  'immaterial',
  'immediate',
  'immense',
  'impassioned',
  'impeccable',
  'impartial',
  'imperfect',
  'impish',
  'impolite',
  'important',
  'impossible',
  'impractical',
  'impressionable',
  'impressive',
  'improbable',
  'impure',
  'inborn',
  'incomparable',
  'incompatible',
  'incomplete',
  'inconsequential',
  'incredible',
  'indelible',
  'inexperienced',
  'indolent',
  'infamous',
  'infantile',
  'infatuated',
  'inferior',
  'infinite',
  'informal',
  'innocent',
  'insecure',
  'insidious',
  'insignificant',
  'insistent',
  'instructive',
  'insubstantial',
  'intelligent',
  'intent',
  'intentional',
  'interesting',
  'internal',
  'international',
  'intrepid',
  'ironclad',
  'irresponsible',
  'irritating',
  'itchy',
  'jaded',
  'jagged',
  'jaunty',
  'jealous',
  'jittery',
  'joint',
  'jolly',
  'jovial',
  'joyful',
  'joyous',
  'jubilant',
  'judicious',
  'juicy',
  'jumbo',
  'junior',
  'jumpy',
  'juvenile',
  'kaleidoscopic',
  'keen',
  'key',
  'kind',
  'kindhearted',
  'kindly',
  'klutzy',
  'knobby',
  'knotty',
  'knowledgeable',
  'knowing',
  'known',
  'kooky',
  'kosher',
  'lame',
  'lanky',
  'large',
  'last',
  'lasting',
  'late',
  'lavish',
  'lawful',
  'lazy',
  'leading',
  'lean',
  'leafy',
  'left',
  'legal',
  'legitimate',
  'light',
  'lighthearted',
  'likable',
  'likely',
  'limited',
  'limp',
  'limping',
  'linear',
  'lined',
  'liquid',
  'little',
  'live',
  'lively',
  'livid',
  'loathsome',
  'lone',
  'lonely',
  'long',
  'loose',
  'lopsided',
  'lost',
  'loud',
  'lovable',
  'lovely',
  'loving',
  'low',
  'loyal',
  'lucky',
  'lumbering',
  'luminous',
  'lumpy',
  'lustrous',
  'luxurious',
  'mad',
  'magnificent',
  'majestic',
  'major',
  'male',
  'mammoth',
  'married',
  'marvelous',
  'masculine',
  'massive',
  'mature',
  'meager',
  'mealy',
  'mean',
  'measly',
  'meaty',
  'medical',
  'mediocre',
  'medium',
  'meek',
  'mellow',
  'melodic',
  'memorable',
  'menacing',
  'merry',
  'messy',
  'metallic',
  'mild',
  'milky',
  'mindless',
  'miniature',
  'minor',
  'minty',
  'miserable',
  'miserly',
  'misguided',
  'misty',
  'mixed',
  'modern',
  'modest',
  'moist',
  'monstrous',
  'monthly',
  'monumental',
  'moral',
  'mortified',
  'motherly',
  'motionless',
  'mountainous',
  'muddy',
  'muffled',
  'multicolored',
  'mundane',
  'murky',
  'mushy',
  'musty',
  'muted',
  'mysterious',
  'naive',
  'narrow',
  'nasty',
  'natural',
  'naughty',
  'nautical',
  'near',
  'neat',
  'necessary',
  'needy',
  'negative',
  'neglected',
  'negligible',
  'neighboring',
  'nervous',
  'new',
  'next',
  'nice',
  'nifty',
  'nimble',
  'nippy',
  'nocturnal',
  'noisy',
  'nonstop',
  'normal',
  'notable',
  'noted',
  'noteworthy',
  'novel',
  'noxious',
  'numb',
  'nutritious',
  'nutty',
  'obedient',
  'obese',
  'oblong',
  'oily',
  'oblong',
  'obvious',
  'occasional',
  'odd',
  'oddball',
  'offbeat',
  'offensive',
  'official',
  'old',
  'only',
  'open',
  'optimal',
  'optimistic',
  'opulent',
  'orderly',
  'organic',
  'ornate',
  'ornery',
  'ordinary',
  'original',
  'other',
  'our',
  'outlying',
  'outgoing',
  'outlandish',
  'outrageous',
  'outstanding',
  'oval',
  'overcooked',
  'overdue',
  'overjoyed',
  'overlooked',
  'palatable',
  'pale',
  'paltry',
  'parallel',
  'parched',
  'partial',
  'passionate',
  'past',
  'pastel',
  'peaceful',
  'peppery',
  'perfect',
  'perfumed',
  'periodic',
  'perky',
  'personal',
  'pertinent',
  'pesky',
  'pessimistic',
  'petty',
  'phony',
  'physical',
  'piercing',
  'pitiful',
  'plain',
  'plaintive',
  'plastic',
  'playful',
  'pleasant',
  'pleased',
  'pleasing',
  'plump',
  'plush',
  'polished',
  'polite',
  'political',
  'pointed',
  'pointless',
  'poised',
  'poor',
  'popular',
  'portly',
  'posh',
  'positive',
  'possible',
  'potable',
  'powerful',
  'powerless',
  'practical',
  'precious',
  'present',
  'prestigious',
  'pretty',
  'precious',
  'previous',
  'pricey',
  'prickly',
  'primary',
  'prime',
  'pristine',
  'private',
  'prize',
  'probable',
  'productive',
  'profitable',
  'profuse',
  'proper',
  'proud',
  'prudent',
  'punctual',
  'pungent',
  'puny',
  'pure',
  'pushy',
  'putrid',
  'puzzled',
  'puzzling',
  'quaint',
  'qualified',
  'quarrelsome',
  'queasy',
  'querulous',
  'questionable',
  'quick',
  'quiet',
  'quintessential',
  'quirky',
  'quixotic',
  'quizzical',
  'radiant',
  'ragged',
  'rapid',
  'rare',
  'rash',
  'raw',
  'recent',
  'reckless',
  'rectangular',
  'ready',
  'real',
  'realistic',
  'reasonable',
  'reflecting',
  'regal',
  'regular',
  'reliable',
  'relieved',
  'remarkable',
  'remorseful',
  'remote',
  'repentant',
  'required',
  'respectful',
  'responsible',
  'repulsive',
  'revolving',
  'rewarding',
  'rich',
  'rigid',
  'right',
  'ringed',
  'ripe',
  'roasted',
  'robust',
  'rosy',
  'rotating',
  'rotten',
  'rough',
  'round',
  'rowdy',
  'royal',
  'rubbery',
  'rundown',
  'ruddy',
  'rude',
  'runny',
  'rural',
  'rusty',
  'sad',
  'safe',
  'salty',
  'same',
  'sandy',
  'sane',
  'sarcastic',
  'sardonic',
  'satisfied',
  'scaly',
  'scarce',
  'scared',
  'scary',
  'scented',
  'scholarly',
  'scientific',
  'scornful',
  'scratchy',
  'scrawny',
  'second',
  'secondary',
  'second-hand',
  'secret',
  'selfish',
  'sentimental',
  'separate',
  'serene',
  'serious',
  'serpentine',
  'several',
  'severe',
  'shabby',
  'shadowy',
  'shady',
  'shallow',
  'shameful',
  'shameless',
  'sharp',
  'shimmering',
  'shiny',
  'shocked',
  'shocking',
  'shoddy',
  'short',
  'showy',
  'shrill',
  'shy',
  'sick',
  'silent',
  'silky',
  'silly',
  'similar',
  'simple',
  'simplistic',
  'sinful',
  'single',
  'sizzling',
  'skeletal',
  'skinny',
  'sleepy',
  'slight',
  'slim',
  'slimy',
  'slippery',
  'slow',
  'slushy',
  'small',
  'smart',
  'smoggy',
  'smooth',
  'smug',
  'snappy',
  'snarling',
  'sneaky',
  'sniveling',
  'snoopy',
  'sociable',
  'soft',
  'soggy',
  'solid',
  'somber',
  'some',
  'spherical',
  'sophisticated',
  'sore',
  'sorrowful',
  'soulful',
  'soupy',
  'sour',
  'sparkling',
  'sparse',
  'specific',
  'spectacular',
  'speedy',
  'spicy',
  'spiffy',
  'spirited',
  'spiteful',
  'splendid',
  'spotless',
  'spotted',
  'spry',
  'square',
  'squeaky',
  'squiggly',
  'stable',
  'staid',
  'stained',
  'stale',
  'standard',
  'starchy',
  'stark',
  'starry',
  'steep',
  'sticky',
  'stiff',
  'stimulating',
  'stingy',
  'stormy',
  'straight',
  'strange',
  'steel',
  'strict',
  'strident',
  'striking',
  'striped',
  'strong',
  'studious',
  'stunning',
  'stupendous',
  'stupid',
  'sturdy',
  'stylish',
  'subdued',
  'submissive',
  'substantial',
  'subtle',
  'suburban',
  'sudden',
  'sugary',
  'sunny',
  'super',
  'superb',
  'superficial',
  'superior',
  'supportive',
  'surprised',
  'suspicious',
  'svelte',
  'sweaty',
  'sweet',
  'sweltering',
  'swift',
  'sympathetic',
  'tall',
  'talkative',
  'tame',
  'tangible',
  'tart',
  'tasty',
  'tattered',
  'taut',
  'tedious',
  'teeming',
  'tempting',
  'tender',
  'tense',
  'tepid',
  'terrible',
  'terrific',
  'testy',
  'thankful',
  'that',
  'these',
  'thick',
  'thin',
  'third',
  'thirsty',
  'this',
  'thorough',
  'thorny',
  'those',
  'thoughtful',
  'threadbare',
  'thrifty',
  'thunderous',
  'tidy',
  'tight',
  'timely',
  'tinted',
  'tiny',
  'tired',
  'torn',
  'total',
  'tough',
  'traumatic',
  'treasured',
  'tremendous',
  'tragic',
  'trained',
  'tremendous',
  'triangular',
  'tricky',
  'trifling',
  'trim',
  'trivial',
  'troubled',
  'true',
  'trusting',
  'trustworthy',
  'trusty',
  'truthful',
  'tubby',
  'turbulent',
  'twin',
  'ugly',
  'ultimate',
  'unacceptable',
  'unaware',
  'uncomfortable',
  'uncommon',
  'unconscious',
  'understated',
  'unequaled',
  'uneven',
  'unfinished',
  'unfit',
  'unfolded',
  'unfortunate',
  'unhappy',
  'unhealthy',
  'uniform',
  'unimportant',
  'unique',
  'united',
  'unkempt',
  'unknown',
  'unlawful',
  'unlined',
  'unlucky',
  'unnatural',
  'unpleasant',
  'unrealistic',
  'unripe',
  'unruly',
  'unselfish',
  'unsightly',
  'unsteady',
  'unsung',
  'untidy',
  'untimely',
  'untried',
  'untrue',
  'unused',
  'unusual',
  'unwelcome',
  'unwieldy',
  'unwilling',
  'unwitting',
  'unwritten',
  'upbeat',
  'upright',
  'upset',
  'urban',
  'usable',
  'used',
  'useful',
  'useless',
  'utilized',
  'utter',
  'vacant',
  'vague',
  'vain',
  'valid',
  'valuable',
  'vapid',
  'variable',
  'vast',
  'velvety',
  'venerated',
  'vengeful',
  'verifiable',
  'vibrant',
  'vicious',
  'victorious',
  'vigilant',
  'vigorous',
  'villainous',
  'violent',
  'virtual',
  'virtuous',
  'visible',
  'vital',
  'vivacious',
  'vivid',
  'voluminous',
  'warlike',
  'warm',
  'warmhearted',
  'warped',
  'wary',
  'wasteful',
  'watchful',
  'waterlogged',
  'watery',
  'wavy',
  'wealthy',
  'weary',
  'webbed',
  'weekly',
  'weepy',
  'weighty',
  'weird',
  'welcome',
  'wet',
  'which',
  'whimsical',
  'whirlwind',
  'whispered',
  'whole',
  'whopping',
  'wicked',
  'wide',
  'wiggly',
  'wild',
  'willing',
  'wilted',
  'winding',
  'windy',
  'winged',
  'wiry',
  'wise',
  'witty',
  'wobbly',
  'woeful',
  'wonderful',
  'wooden',
  'woozy',
  'wordy',
  'worldly',
  'worn',
  'worried',
  'worrisome',
  'worse',
  'worst',
  'worthless',
  'worthwhile',
  'worthy',
  'wrathful',
  'wretched',
  'writhing',
  'wrong',
  'wry',
  'yawning',
  'yearly',
  'yellowish',
  'young',
  'youthful',
  'yummy',
  'zany',
  'zealous',
  'zesty',
  'zigzag',
];

const greetings = [
  'hallo',
  'Përshëndetje',
  'ሰላም',
  'مرحبا',
  'Բարեւ',
  'Salam',
  'Kaixo',
  'добры дзень',
  'হ্যালো',
  'zdravo',
  'Здравейте',
  'Hola',
  'Hello',
  'Moni',
  '您好',
  'Bonghjornu',
  'zdravo',
  'Ahoj',
  'Hej',
  'Hallo',
  'Saluton',
  'Tere',
  'Kumusta',
  'Hei',
  'Bonjour',
  'Ola',
  'გამარჯობა',
  'Hallo',
  'Γεια σας',
  'હેલો',
  'Bonjou',
  'Sannu',
  'Alohaʻoe',
  'שלום',
  'नमस्ते',
  'Nyob zoo',
  'Helló',
  'Halló',
  'Ndewo',
  'Halo',
  'Dia duit',
  'Ciao',
  'こんにちは',
  'ಹಲೋ',
  'Сәлем',
  'ជំរាបសួរ',
  '안녕하세요.',
  'салам',
  'ສະບາຍດີ',
  'salve',
  'Labdien!',
  'Sveiki',
  'Moien',
  'Здраво',
  'ഹലോ',
  'Hiha',
  'हॅलो',
  'Сайн байна уу',
  'မင်္ဂလာပါ',
  'नमस्ते',
  'سلام',
  'Cześć',
  'Olá',
  'ਹੈਲੋ',
  'Alo',
  'привет',
  'Talofa',
  'Здраво',
  'هيلو',
  'හෙලෝ',
  'ahoj',
  'Pozdravljeni',
  'Sawa',
  'Hallå',
  'Салом',
  'ஹலோ',
  'హలో',
  'สวัสดี',
  'Merhaba',
  'Здрастуйте',
  'ہیلو',
  'Salom',
  'Xin chào',
  'Helo',
  'Sawubona',
  'העלא',
  'Kaabo',
  'Sawubona',
];

export const palette: string[] = [
  '#ff6497',
  '#70d0ff',
  '#ffb358',
  '#bd9bf7',
  '#9dd841',
  '#edb627',
];

export const objects: ShuffleObject[] = [
  { avatar: chicken, noun: 'chicken' },
  { avatar: giraffe, noun: 'giraffe' },
  { avatar: horse, noun: 'horse' },
  { avatar: koala, noun: 'koala' },
  { avatar: pig, noun: 'pig' },
];

export const shuffle = (): Shuffler => {
  const randomObject = objects[Math.floor(Math.random() * objects.length)];
  const randomColor = palette[Math.floor(Math.random() * palette.length)];
  const randomAdjective =
    adjectives[Math.floor(Math.random() * adjectives.length)];

  return {
    object: randomObject,
    color: randomColor,
    adjective: randomAdjective,
  };
};

export const shuffleColor = () => {
  const randomColor = palette[Math.floor(Math.random() * palette.length)];
  return randomColor;
};

export function getRandomLatitude(min = -90, max = 90) {
  return Math.random() * (max - min) + min;
}

export function getRandomLongitude(min = -180, max = 180) {
  return Math.random() * (max - min) + min;
}

export function getRandomTimeLeft(min = 0, max = 100) {
  return Math.random() * (max - min) + min;
}

export function getRandomEmoji() {
  const randomEmoji = emojiArray[Math.floor(Math.random() * emojiArray.length)];
  return randomEmoji;
}

export function getRandomGreeting() {
  const randomGreeting =
    greetings[Math.floor(Math.random() * greetings.length)];
  return randomGreeting;
}

export const calculatePathColor = (value: number) => {
  const red =
    value < 50 ? 255 - (value / 50) * 0 : 255 - ((value - 50) / 50) * 208;
  const green =
    value < 50 ? 56 + (value / 50) * 157 : 213 + ((value - 50) / 50) * 26;
  const blue =
    value < 50 ? 112 - (value / 50) * 43 : 69 + ((value - 50) / 50) * 141;

  return `rgb(${red}, ${green}, ${blue})`;
};

// const getPathColor = () => {
//   // rgb(255, 56, 112)    # Dying Chat
//   // rgb(255, 213, 69,1)  # Inactive Chat
//   // rgb(47, 239, 210)    # Good Active Chat

//   const red =
//     value < 50 ? 255 - (value / 50) * 0 : 255 - ((value - 50) / 50) * 208;
//   const green =
//     value < 50 ? 56 + (value / 50) * 157 : 213 + ((value - 50) / 50) * 26;
//   const blue =
//     value < 50 ? 112 - (value / 50) * 43 : 69 + ((value - 50) / 50) * 141;

//   return `rgb(${red}, ${green}, ${blue})`;
// };
